// Mirrors src/Domain/Enums/DocumentStatus.cs — the API sends/accepts the numeric value.
import { STATE_COLORS } from './statusColors';

export const DOCUMENT_STATUS = Object.freeze({
  DRAFT: 0,
  EFFECTIVE: 1,
  SUPERSEDED: 2,
  OBSOLETE: 3,
});

export const DOCUMENT_STATUS_LABELS = Object.freeze({
  [DOCUMENT_STATUS.DRAFT]: 'Draft',
  [DOCUMENT_STATUS.EFFECTIVE]: 'Effective',
  [DOCUMENT_STATUS.SUPERSEDED]: 'Superseded',
  [DOCUMENT_STATUS.OBSOLETE]: 'Obsolete',
});

// Superseded and Obsolete are end-of-life, not failures, so they stay in the neutral
// bucket — red is reserved for problem states.
export const DOCUMENT_STATUS_COLORS = Object.freeze({
  [DOCUMENT_STATUS.DRAFT]: STATE_COLORS.DRAFT,
  [DOCUMENT_STATUS.EFFECTIVE]: STATE_COLORS.COMPLETE,
  [DOCUMENT_STATUS.SUPERSEDED]: STATE_COLORS.DRAFT,
  [DOCUMENT_STATUS.OBSOLETE]: STATE_COLORS.DRAFT,
});

export const DOCUMENT_STATUS_OPTIONS = Object.freeze(
  Object.values(DOCUMENT_STATUS).map((value) => ({ value, label: DOCUMENT_STATUS_LABELS[value] })),
);
